var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5, _circle6, _g, _circle7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingValidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 277,
    viewBox: "0 0 274 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 216.851,
    cy: 50.6517,
    r: 33.2399,
    fill: "#FFD445"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6145,
    cy: 190.734,
    r: 19.7857,
    fill: "#FFD445"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.048,
    cy: 255.632,
    r: 19.7857,
    fill: "#FFD445"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.523,
    cy: 228.723,
    r: 7.12284,
    fill: "#FFD445"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.214,
    cy: 127.42,
    r: 7.12284,
    fill: "#FFD445"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8603 110.141C56.0524 110.141 61.0721 105.121 61.0721 98.929C61.0721 92.7368 56.0524 87.7171 49.8603 87.7171C43.6681 87.7171 38.6484 92.7368 38.6484 98.929C38.6484 105.121 43.6681 110.141 49.8603 110.141ZM49.8603 112.383C57.2908 112.383 63.3145 106.36 63.3145 98.929C63.3145 91.4984 57.2908 85.4747 49.8603 85.4747C42.4297 85.4747 36.406 91.4984 36.406 98.929C36.406 106.36 42.4297 112.383 49.8603 112.383Z",
    fill: "#FFD445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.42 274.757C133.612 274.757 138.632 269.738 138.632 263.546C138.632 257.353 133.612 252.334 127.42 252.334C121.228 252.334 116.208 257.353 116.208 263.546C116.208 269.738 121.228 274.757 127.42 274.757ZM127.42 277C134.851 277 140.874 270.976 140.874 263.546C140.874 256.115 134.851 250.091 127.42 250.091C119.989 250.091 113.966 256.115 113.966 263.546C113.966 270.976 119.989 277 127.42 277Z",
    fill: "#FFD445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4991 25.8529C23.5077 31.6215 20.0844 44.3974 25.8529 54.3888C31.6215 64.3802 44.3974 67.8036 54.3889 62.035C64.3803 56.2665 67.8036 43.4905 62.035 33.4991C56.2665 23.5077 43.4905 20.0844 33.4991 25.8529ZM27.8593 16.0845C12.473 24.9678 7.20124 44.6423 16.0846 60.0286C24.9679 75.415 44.6423 80.6867 60.0286 71.8034C75.415 62.9201 80.6867 43.2457 71.8034 27.8593C62.9201 12.473 43.2457 7.20123 27.8593 16.0845Z",
    fill: "#FFD445"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0011 92.2641C15.7599 93.5581 14.9921 96.4238 16.286 98.6649C17.5799 100.906 20.4457 101.674 22.6868 100.38C24.9279 99.0861 25.6958 96.2204 24.4019 93.9792C23.108 91.7381 20.2422 90.9702 18.0011 92.2641ZM17.5325 91.4525C14.8432 93.0053 13.9217 96.4441 15.4744 99.1335C17.0271 101.823 20.466 102.744 23.1554 101.192C25.8447 99.6389 26.7662 96.2 25.2135 93.5107C23.6608 90.8213 20.2219 89.8998 17.5325 91.4525Z",
    fill: "#FFD445"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.464 236.304C139.222 237.598 138.455 240.463 139.749 242.705C141.042 244.946 143.908 245.714 146.149 244.42C148.39 243.126 149.158 240.26 147.864 238.019C146.57 235.778 143.705 235.01 141.464 236.304ZM140.995 235.492C138.306 237.045 137.384 240.484 138.937 243.173C140.49 245.862 143.929 246.784 146.618 245.231C149.307 243.679 150.229 240.24 148.676 237.55C147.123 234.861 143.684 233.939 140.995 235.492Z",
    fill: "#FFD445"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.666,
    cy: 143.249,
    r: 92.597,
    fill: "#FFD445"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_770_4083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.73 84.4458C143.169 74.9012 130.475 69.6303 117.005 69.6461C103.487 69.6461 90.7769 74.917 81.2323 84.5249C71.7193 94.0854 66.4801 106.748 66.4801 120.187C66.4801 148.045 89.1624 170.711 117.021 170.695C130.538 170.695 143.264 165.393 152.825 155.801C162.338 146.24 167.561 133.593 167.561 120.155C167.561 106.669 162.29 93.9904 152.73 84.43V84.4458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.989 173.861C87.4055 173.861 63.3145 149.786 63.3145 120.187C63.3145 105.909 68.8703 92.455 78.9847 82.2931C89.1308 72.0995 102.617 66.4804 116.973 66.4804C131.33 66.4804 144.816 72.0679 154.962 82.214C165.124 92.3601 170.711 105.83 170.711 120.171C170.711 134.448 165.155 147.902 155.057 158.049C144.879 168.258 131.377 173.877 117.021 173.877L116.989 170.711L117.021 167.546C129.699 167.546 141.602 162.591 150.577 153.585C159.489 144.642 164.38 132.77 164.38 120.171C164.38 107.524 159.441 95.6366 150.482 86.6935C141.523 77.7503 129.636 72.8118 117.021 72.8118C104.405 72.8118 92.4073 77.7662 83.4642 86.7568C74.5527 95.7157 69.63 107.603 69.6459 120.187C69.6459 146.304 90.8878 167.53 116.989 167.53V173.861Z",
    fill: "#343C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.37 148.393C137.788 156.007 127.721 160.185 117.021 160.201C94.9557 160.217 76.9903 142.267 77.0061 120.202C77.0061 109.55 81.1532 99.5304 88.6876 91.9644C96.2536 84.3509 106.321 80.1721 117.005 80.1721C127.689 80.1721 137.724 84.3192 145.306 91.9011C152.872 99.4671 157.051 109.518 157.051 120.187C157.051 130.823 152.92 140.843 145.37 148.409V148.393Z",
    fill: "#CFD5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6848 120.187H83.3534C83.3534 111.228 86.8515 102.791 93.1829 96.4438C99.546 90.0491 107.998 86.5352 117.005 86.5352V92.8666C109.708 92.8666 102.838 95.7315 97.6782 100.923C92.5339 106.083 89.7006 112.937 89.7006 120.202L89.6848 120.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.878 156.118L152.974 175.022L194.207 216.255L213.111 197.351L171.878 156.118Z",
    fill: "#FABE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.487 172.454L176.01 176.931L198.854 199.775L203.331 195.298L180.487 172.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.737 158.286L155.142 172.881L162.294 180.033L176.889 165.438L169.737 158.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.275 184.498L150.656 172.864L169.73 153.791L181.348 165.409L162.275 184.482V184.498ZM159.599 172.864L162.275 175.539L172.389 165.425L169.714 162.75L159.599 172.864V172.864Z",
    fill: "#343C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.461 203.017C214.461 211.074 207.924 217.611 199.867 217.611C198.696 216.44 197.54 215.285 196.369 214.113C201.244 209.254 206.104 204.379 210.963 199.519C212.134 200.691 213.306 201.846 214.461 203.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.553 220.777L191.89 214.113L210.947 195.04L217.627 201.704V203.017C217.627 212.799 209.665 220.777 199.867 220.777H198.553V220.777ZM200.833 214.113L201.102 214.382C206.42 213.797 210.646 209.57 211.216 204.268L210.947 203.999L200.833 214.113Z",
    fill: "#343C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.101 161.316L150.624 165.793L156.735 171.904L161.212 167.427L155.101 161.316Z",
    fill: "#343C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.704 149.829L154.226 154.305L162.138 162.219L166.616 157.743L158.704 149.829Z",
    fill: "#343C46"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.874,
    cy: 144.04,
    r: 107.634,
    stroke: "#363853",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "6 10"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_770_4083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.312,
    height: 154.297,
    fill: "white",
    transform: "translate(63.3145 66.4804)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingValidate);
export default __webpack_public_path__ + "static/media/PendingValidate.397b54da9a55ae46eda2929761ccd0b5.svg";
export { ForwardRef as ReactComponent };